import styled from "styled-components";
import Button from "components/Button";
import COLORS from "shared/constants/colors";

const Container = styled.div`
  display: grid;
  column-gap: 10px;
  row-gap: 10px;
  @media (min-width: 992px) {
    grid-template-columns: repeat(4, 1fr);
  }
  > div {
    @media (min-width: 992px) {
      :first-child {
        grid-column: 1 / span 2;
        position: sticky;
        top: 0.5em;
      }
      :nth-child(2),
      :nth-child(3) {
        grid-column: 3 / span 2;
      }
    }
  }
`;
const OrderDetail = styled.div`
  min-height: 150px;
  box-shadow: 4px 4px 10px #d9d9d9, -4px -4px 10px #ffffff;
  border-radius: 5px;
  background-color: ${COLORS.WHITE};
  margin-bottom: 20px;
`;
const Heading = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: #6d6e71;
  font-weight: 600;
  padding: 10px 15px;
`;

const Panel = styled.div`
  padding: 0 15px;
`;
const MoreDetail = styled.div`
  > h4 {
    color: #6d6e71;
    text-transform: uppercase;
    letter-spacing: 1px;
    font-weight: normal;
    text-align: center;
    padding: 3px;
    border: 1px solid #e7eaec;
    max-width: fit-content;
    margin: 0 auto;
  }
  > div {
    border: 1px solid #c7c8c9;
    padding: 0 12px;
    display: grid;
    grid-template-columns: 1fr;
    column-gap: 10px;
    margin: 12px 0;
    @media (min-width: 512px) {
      grid-template-columns: 1fr 1fr;
    }
    img {
      width: 100% !important;
      height: 100% !important;
      object-fit: contain !important;
      border-radius: 4px;
      background: #fbfbfb;
    }
    ul {
      padding: 0;
      margin-top: 50px;
      li {
        display: flex;
        padding: 5px 0;
        span {
          :first-child {
            margin-right: 0.5em;
            font-weight: 700;
            width: 190px;
          }
          :last-child {
            flex: 1;
          }
        }
      }
    }
  }
`;
const OrderTotal = styled.div`
  margin-top: 12.5px;
  border-top: 2px solid #6d6e71;
  padding-top: 12.5px;
  > div {
    display: grid;
    grid-template-columns: 1fr 1fr;
    margin-bottom: 12.5px;
    color: #3b3b3d;
    font-weight: 600;
    span {
      :last-child {
        justify-self: end;
      }
    }
    b {
      color: rgb(153, 153, 153);
      font-weight: 700;
    }
  }
`;
const Total = styled.span`
  font-size: 19px;
`;

const ShippingMessage = styled.p`
  color: red;
  font-size: 16px;
`;

const ProductImage = styled.div`
  width: 70%;
  margin: auto;
`;

const SlickContainer = styled.div`
  width: 200px;
  margin: 10px auto 30px;
  .slick-dots {
    display: flex !important;
    justify-content: center;
  }
`;

const PackingOptions = styled.div`
  border-top: 1px solid #ccc;
  grid-template-columns: ${(props) =>
    props?.singleBox ? "1fr auto !important" : "1fr 1fr !important"};
  gap: ${(props) => (props?.singleBox ? 0 : "20px")};
  padding: 10px;
  display: grid;
`;

const PackingOption = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: column;
  font-size: 15px;
  gap: 4px;
  border: ${(props) =>
    props?.selected
      ? `2px dashed ${props?.eco ? "green" : "#ffd363"}`
      : "1px solid #ccc"};
  color: ${(props) =>
    props?.selected ? (props?.eco ? "green" : "inherit") : "#a1a1a1"};

  border-radius: 5px;
  padding: 16px;
  cursor: pointer;
`;

const BemerchfullButton = styled(Button)`
  margin: 10px auto;
  display: block;
  background-color: black;
  color: white;
  font-size: 10px;
  font-weight: bold;
  :hover {
    background-color: black;
    color: white;
  }
`;

const ColorField = styled.span`
  display: flex;
  gap: 10px;
  align-items: center;
  input {
    padding: 0 10px;
    height: 28px;
    width: 100px;
  }
`;

export {
  Container,
  OrderDetail,
  Heading,
  Panel,
  MoreDetail,
  OrderTotal,
  Total,
  ShippingMessage,
  ProductImage,
  SlickContainer,
  PackingOptions,
  PackingOption,
  BemerchfullButton,
  ColorField,
};
